<div class="resource-skeleton">
  @for (i of [0, 1]; track i) {
    <div class="resource-skeleton__column">
      @for (i of [0, 1, 2, 3, 4, 5]; track i) {
        <div class="resource-skeleton__paragraph">
          @for (i of [0, 1, 2, 3, 4, 5, 6]; track i) {
            <nr-skeleton></nr-skeleton>
          }
          <nr-skeleton [type]="'medium'"></nr-skeleton>
        </div>
      }
    </div>
  }
</div>
